import React from 'react'
import { GetServerSideProps } from 'next'
import { ConsumerPage } from '../src/model'
import { HomePage as HomeEntryPage } from '../src/page/HomePage'
import { getLayout } from '../src/layouts/MainLayout'
import { createCombinedServerSideProps } from '../src/utils/server/page-props'

const I18N_NAMESPACE = [
  'common',
  'terminalError',
  'index',
  'account',
  'payments',
  'upcomingPayments',
  'cardScan',
  'oauth',
  'ach',
  'orders',
  'loyalty',
  'payMonthly',
  'welcomeWithInitialLimit',
]

const HomePage: ConsumerPage = (props) => <HomeEntryPage {...props} />
HomePage.getLayout = getLayout()

export const getServerSideProps: GetServerSideProps = createCombinedServerSideProps(I18N_NAMESPACE)
export default HomePage
